import { Group } from 'src/design/atoms/Group';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { DrawingDto } from 'src/api/FiretrolApiClient';
import { useAuth } from 'src/hooks/useAuth';
import { useJobs } from 'src/hooks/useJobs';
import { SecondaryButton } from 'src/design/atoms/SecondaryButton';
import { Header } from 'src/design/organisms/Header';
import { jobBreadcrumbs } from 'src/app/workflows/jobBreadcrumbs';
import { DrawingForm } from 'src/routes/Jobs/Drawings/components/DrawingForm';

const emptyDrawing: Partial<DrawingDto> = {
  title: '',
  type: 'type_1',
  intentOfReview: 'review',
  assignee: undefined,
  company: '',
  drawingNumber: '',
  externalDrawingNumber: '',
  status: '',
  workflow: undefined,
  assigneeUserId: undefined,
  attachments: [],
  revisions: [],
  stepIndex: -1,
  job: undefined,
  id: '',
  createdAt: undefined,
  reporter: undefined,
  submittedOn: undefined,
  updatedAt: undefined,
  history: [],
  milestonePhaseItemId: undefined,
  submittedToContactId: undefined,
  submittedToContact: undefined,
};

export const SubmitDrawing: React.FC = () => {
  const { selectedJob } = useJobs();
  const { user } = useAuth();
  const navigate = useNavigate();
  const initialValues: DrawingDto = React.useMemo(() => {
    return {
      ...emptyDrawing,
      id: '',
      drawingId: 0,
      jobId: selectedJob?.id,
      workflowId: selectedJob?.drawingWorkflowId ?? undefined,
      workflow: selectedJob?.drawingWorkflow ?? undefined,
      reporterUserId: user?.id,
    } as DrawingDto;
  }, [selectedJob?.drawingWorkflow, user?.id]);
  if (!selectedJob) return null;
  return (
    <>
      <Header
        breadcrumbProps={{
          items: jobBreadcrumbs(
            selectedJob,
            { text: 'Drawings', href: `/jobs/${selectedJob.id}/drawings` },
            'Create Drawing',
          ),
        }}
        title="Create Drawing"
        helpText="Create a new drawing for this job."
      />
      <Group justify="flex-end" mb="md">
        <SecondaryButton
          onClick={() => navigate(`/jobs/${selectedJob.id}/drawings`)}
        >
          Cancel
        </SecondaryButton>
      </Group>
      <DrawingForm
        initialValues={initialValues}
        selectedJob={selectedJob}
        onSaved={(drawing) =>
          navigate(`/jobs/${selectedJob.id}/drawings/${drawing.id}`)
        }
        onCreated={(drawing) =>
          navigate(`/jobs/${selectedJob.id}/drawings/${drawing.id}`)
        }
      />
    </>
  );
};
